import RoutesSsp from './RoutesSsp';
import ThemeRouteName from '../../../administration/pages/theme/const/ThemeRouteName';
import RouteNames from '../RouteNames';

const routes = [
  {
    path: '/administration/overview/landingPage',
    name: 'landingPage',
    component: () => import('../../../administration/pages/landingPage/LandingPage.vue'),
  },
  {
    path: '/administration/management/vcomApi',
    name: 'vcomApi',
    component: () => import('../../../administration/pages/VcomApi.vue'),
  },
  {
    path: '/administration/user/contactList',
    name: 'contactList',
    component: () => import('../../../administration/pages/contactList/ContactList.vue'),
  },
  {
    path: '/administration/user/teams',
    name: 'teams',
    component: () => import('../../../administration/pages/teams/Teams.vue'),
  },
  {
    path: `/administration/settings/${ThemeRouteName.THEME_MANAGER}/overview`,
    name: ThemeRouteName.THEME_MANAGER,
    component: () => import('../../../administration/pages/theme/theme.vue'),
  },
  {
    path: '/administration/cmms/servicePartner',
    name: 'servicePartner',
    component: () => import('../../../administration/pages/ServicePartner.vue'),
  },
  {
    path: '/administration/settings/globalSettings',
    name: 'globalSettings',
    component: () => import('../../../administration/pages/globalSettings/GlobalSettings.vue'),
  },
  {
    path: '/administration/cmms/template',
    name: 'template',
    component: () => import('../../../cmms/forms/component/FormTemplates.vue'),
  },
  {
    path: '/administration/cmms/reportTemplate',
    name: 'reportTemplate',
    component: () => import('../../../administration/pages/cmms/reportTemplate/ReportTemplatePage.vue'),
  },
  {
    path: '/administration/cmms/reportTemplate/create',
    name: 'reportTemplate/create',
    component: () => import('../../../administration/pages/cmms/reportTemplate/ReportTemplateCreatePage.vue'),
  },
  {
    path: '/administration/cmms/reportTemplate/edit',
    name: 'reportTemplate/edit',
    component: () => import('../../../administration/pages/cmms/reportTemplate/ReportTemplateEditPage.vue'),
    props: true,
  },
  {
    path: '/administration/management/cloudBackup',
    name: 'cloudBackup',
    component: () => import('../../../administration/pages/cloudBackup/CloudBackup.vue'),
  },
  {
    path: '/administration/management/systemManagement',
    name: 'systemManagement',
    component: () => import('../../../administration/pages/cmms/systemManagement/SystemManagement.vue'),
  },
  {
    path: '/administration/management/batteryMonitoring',
    name: 'batteryMonitoring',
    component: () => import('../../../administration/pages/batteryMonitoring/BatteryMonitoring.vue'),
  },
  {
    path: '/administration/management/solarPowerForecastManagement',
    name: 'solarPowerForecastManagement',
    component: () => import('../../../administration/pages/solarPowerForecastManagement/SolarPowerForecastManagement.vue'),
  },
  {
    path: '/administration/overview/administration',
    name: 'administration',
    component: () => import('../../../administration/pages/administration/Administration.vue'),
  },
  {
    path: '/administration/user/messages',
    name: 'messages',
    component: () => import('../../../administration/pages/messages/Messages.vue'),
  },
  {
    path: '/administration/user/messages/create',
    name: 'create',
    component: () => import('../../../administration/pages/messages/Messages.vue'),
  },
  {
    path: '/administration/user/messages/edit/:id',
    name: 'edit',
    component: () => import('../../../administration/pages/messages/Messages.vue'),
  },
  {
    path: '/administration/settings/ticketCauses',
    name: 'ticketCauses',
    component: () => import('../../../administration/pages/ticketCauses/TicketCauses.vue'),
  },
  {
    path: '/administration/automation/automations',
    name: 'automations',
    component: () => import('../../../administration/pages/automation/Automations.vue'),
  },
  {
    path: '/administration',
    name: RouteNames.START,
  },
  {
    path: '/',
    name: RouteNames.BASE,
  },
  {
    path: '*',
    name: RouteNames.PAGE_NOT_FOUND,
    component: () => import('../../../common/layout/PageNotFound.vue'),
  },
  {
    path: '/administration/overview/systemFilters',
    name: 'systemFilters',
    component: () => import('../../../administration/pages/systemFilters/SystemFilters.vue'),
  },
];

export default [...RoutesSsp, ...routes];
